import { axiosBase } from 'utils';

/* Projects */
export function timeTrackerProjectsListService() {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/projects',
  });
}

export function timeTrackerProjectGetService(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/projects/' + id,
  });
}

export function timeTrackerProjectAnalyticsService(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/projects/' + id + '/analytics',
  });
}

export function timeTrackerProjectCreateService(values) {
  const axios = axiosBase.create();
  return axios({
    method: 'POST',
    url: '/time-tracker/projects',
    data: {
      company: values.company,
      branch: values.branch,
      project_name: values.project_name,
      project_description: values.project_description || '',
      color: values.color,
      team: values.team || [],
      assigned_groups: values.assigned_groups || [],
      status: values.status || 'active',
    },
  });
}

export function timeTrackerProjectUpdateService(id, values) {
  const axios = axiosBase.create();
  return axios({
    method: 'PATCH',
    url: '/time-tracker/projects/' + id,
    data: {
      company: values.company,
      branch: values.branch,
      project_name: values.project_name,
      project_description: values.project_description || '',
      color: values.color,
      team: values.team || [],
      assigned_groups: values.assigned_groups || [],
      status: values.status || 'active',
    },
  });
}

export function timeTrackerProjectDeleteService(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'DELETE',
    url: '/time-tracker/projects/' + id,
  });
}

/** Scoped client users plus Super Admin / MSP staff (roles 10–13) for team & access-group pickers */
export function timeTrackerAssignableUsersListService() {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/assignable-users',
  });
}

/* User groups (project access) */
export function timeTrackerUserGroupsListService() {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/user-groups',
  });
}

export function timeTrackerUserGroupGetService(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/user-groups/' + id,
  });
}

export function timeTrackerUserGroupCreateService(values) {
  const axios = axiosBase.create();
  return axios({
    method: 'POST',
    url: '/time-tracker/user-groups',
    data: {
      group_name: values.group_name,
      members: values.members || [],
    },
  });
}

export function timeTrackerUserGroupUpdateService(id, values) {
  const axios = axiosBase.create();
  return axios({
    method: 'PATCH',
    url: '/time-tracker/user-groups/' + id,
    data: {
      group_name: values.group_name,
      members: values.members || [],
    },
  });
}

export function timeTrackerUserGroupDeleteService(id) {
  const axios = axiosBase.create();
  return axios({
    method: 'DELETE',
    url: '/time-tracker/user-groups/' + id,
  });
}

/* Entries (timer) */
/**
 * @param {string|{
 *   project?: string,
 *   task_title?: string,
 *   task_description?: string,
 *   schedule_shift?: string,
 *   schedule_activity?: string
 * }} payload
 */
export function timeTrackerEntryStartService(payload) {
  const axios = axiosBase.create();
  const body =
    typeof payload === 'string'
      ? { project: payload }
      : { ...payload };
  if (!body.project) delete body.project;
  if (!body.schedule_shift) delete body.schedule_shift;
  if (!body.schedule_activity) delete body.schedule_activity;
  return axios({
    method: 'POST',
    url: '/time-tracker/entries/start',
    data: body,
  });
}

export function timeTrackerEntryStopService(entryId, payload = {}) {
  const axios = axiosBase.create();
  const data = {
    task_title: payload.task_title || '',
    task_description: payload.task_description || '',
  };
  if (payload.project != null && String(payload.project).trim() !== '') {
    data.project = String(payload.project).trim();
  }
  return axios({
    method: 'PATCH',
    url: '/time-tracker/entries/' + entryId + '/stop',
    data,
  });
}

export function timeTrackerEntryGetRunningService() {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/entries/running',
  });
}

export function timeTrackerEntryGetMyService(params = {}) {
  const axios = axiosBase.create();
  const q = new URLSearchParams(params).toString();
  return axios({
    method: 'GET',
    url: '/time-tracker/entries/my' + (q ? '?' + q : ''),
  });
}

export function timeTrackerEntryGetByProjectService(projectId) {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/entries/by-project/' + projectId,
  });
}

export function timeTrackerEntryGetOneService(entryId) {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/entries/' + entryId,
  });
}

export function timeTrackerEntryDeleteService(entryId) {
  const axios = axiosBase.create();
  return axios({
    method: 'DELETE',
    url: '/time-tracker/entries/' + entryId,
  });
}

export function timeTrackerEntryUpdateService(entryId, payload = {}) {
  const axios = axiosBase.create();
  const data = {};
  if ('task_title' in payload) data.task_title = payload.task_title ?? '';
  if ('task_description' in payload)
    data.task_description = payload.task_description ?? '';
  if ('started_at' in payload && payload.started_at != null) {
    data.started_at =
      typeof payload.started_at === 'string'
        ? payload.started_at
        : new Date(payload.started_at).toISOString();
  }
  if ('stopped_at' in payload && payload.stopped_at != null) {
    data.stopped_at =
      typeof payload.stopped_at === 'string'
        ? payload.stopped_at
        : new Date(payload.stopped_at).toISOString();
  }
  if ('duration_seconds' in payload && payload.duration_seconds != null) {
    data.duration_seconds = payload.duration_seconds;
  }
  if ('project' in payload) {
    if (payload.project == null || payload.project === '') {
      data.project = null;
    } else {
      data.project = String(payload.project).trim();
    }
  }
  return axios({
    method: 'PATCH',
    url: '/time-tracker/entries/' + entryId,
    data,
  });
}

/** Create a manual time entry (no timer). */
export function timeTrackerEntryCreateManualService(payload) {
  const axios = axiosBase.create();
  return axios({
    method: 'POST',
    url: '/time-tracker/entries/manual',
    data: {
      project: payload.project,
      started_at: payload.started_at,
      stopped_at: payload.stopped_at,
      task_title: payload.task_title || '',
      task_description: payload.task_description || '',
    },
  });
}

/**
 * Build a URLSearchParams string that correctly serializes array values as
 * repeated keys (e.g. `?project=a&project=b`). The default
 * `new URLSearchParams(obj)` form turns arrays into `"a,b"` via `String()`
 * which the reports controllers would not split, so we expand them manually.
 */
function buildReportsQueryString(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value == null) return;
    if (Array.isArray(value)) {
      value.forEach((v) => {
        if (v == null) return;
        const s = String(v).trim();
        if (s) usp.append(key, s);
      });
      return;
    }
    const s = String(value).trim();
    if (s) usp.append(key, s);
  });
  return usp.toString();
}

/* Reports */
export function timeTrackerReportsEntriesService(params = {}) {
  const axios = axiosBase.create();
  const q = buildReportsQueryString(params);
  return axios({
    method: 'GET',
    url: '/time-tracker/reports/entries' + (q ? '?' + q : ''),
  });
}

export function timeTrackerReportsSummaryService(params = {}) {
  const axios = axiosBase.create();
  const q = buildReportsQueryString(params);
  return axios({
    method: 'GET',
    url: '/time-tracker/reports/summary' + (q ? '?' + q : ''),
  });
}

/** Team activity: latest entry / running (display); period totals = stopped entries only, like summary. */
export function timeTrackerReportsTeamActivityService(params = {}) {
  const axios = axiosBase.create();
  const q = buildReportsQueryString(params);
  return axios({
    method: 'GET',
    url: '/time-tracker/reports/team-activity' + (q ? '?' + q : ''),
  });
}

/** All running timers, any reseller. Super admin only. */
export function timeTrackerOpenTimersListService() {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: '/time-tracker/entries/open',
  });
}

/** Stop a running timer even when it belongs to another reseller. Super admin only. */
export function timeTrackerOpenTimerStopService(entryId) {
  const axios = axiosBase.create();
  return axios({
    method: 'PATCH',
    url: '/time-tracker/entries/' + entryId + '/admin-stop',
  });
}

export function timeTrackerReportsPayrollService(params = {}) {
  const axios = axiosBase.create();
  const q = buildReportsQueryString(params);
  return axios({
    method: 'GET',
    url: '/time-tracker/reports/payroll' + (q ? '?' + q : ''),
  });
}
